/**
 * Created by stavmeidan on 7/30/15.
 */

'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var Seller = require('bunsen/models/Seller');
var _= require('underscore');
var YES = 'Y';

var SellerPreferences = module.exports = SoaModel.extend({
    url : function () {
        var url = _.result(this.findParent(Seller), 'url') + '/preferences';
        return url;
    },
    defaults: {
        currency: 'USD'
    },

    /**
     * Indicates if seller allows for items to display on store front when sold
     * @return {Boolean}
     */
    isDisplayStoreFrontSold: function() {
        return this.get('displayStoreFrontSold') === YES;
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/identity/SellerPreferences.js
// module id = 2635
// module chunks = 62